import localforage from "localforage";

export default async ({ store, route }) => {
  localforage
    .clear()
    .then(() => console.log("localforage cleared"))
    .catch((err) => console.error(err)); // reset cache on reload APP
  await store.dispatch("nuxtClientInit", route);
};
